import { ErrorBoundaryContext } from "@prismicio/editor-support/Suspense"
import { useContext } from "react"

import type { SX } from "../../theme"
import {
  BlankSlate,
  BlankSlateActions,
  BlankSlateDescription,
  BlankSlateImage,
  BlankSlateTitle,
} from "../BlankSlate"
import { Button } from "../Button"

export interface DefaultErrorMessageProps {
  title: string
  description?: string
  errorImageSrc?: string
  sx?: SX
}

export function DefaultErrorMessage(props: DefaultErrorMessageProps) {
  const { title, description, errorImageSrc, sx } = props

  const context = useContext(ErrorBoundaryContext)

  return (
    <BlankSlate sx={sx}>
      {errorImageSrc && (
        <BlankSlateImage>
          <img src={errorImageSrc} alt="Error" />
        </BlankSlateImage>
      )}
      <BlankSlateTitle size="big">{title}</BlankSlateTitle>
      <BlankSlateDescription>{description}</BlankSlateDescription>
      <BlankSlateActions>
        <Button onClick={context?.reset}>Try again</Button>
      </BlankSlateActions>
    </BlankSlate>
  )
}
